import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-label-print-page',
  templateUrl: './label-print-page.component.html',
  styleUrls: ['./label-print-page.component.scss']
})
export class LabelPrintPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
